import { Component, Input, OnInit } from '@angular/core';
import { getPriceValueForEdition } from '@vendasta/billing-ui';
import { Observable } from 'rxjs';
import { OrderConfirmationItem } from '../interface';
import { OrderSummary, StairstepOrderService } from '../stairstep-order.service';

@Component({
  selector: 'app-order-excess',
  templateUrl: './order-excess.component.html',
  styleUrls: ['./order-excess.component.scss'],
})
export class OrderExcessComponent implements OnInit {
  orderSummary$: Observable<OrderSummary>;
  orderCurrency = '';

  @Input() orderConfirmationItems: OrderConfirmationItem[];

  constructor(private stairstepService: StairstepOrderService) {}

  ngOnInit(): void {
    // If the order items are free, don't bother checking stairstep prices
    const nonFreeOrderConfirmationItems = this.orderConfirmationItems.filter(
      (item) =>
        getPriceValueForEdition(
          item.appPrices.pricesForContexts['wholesale'],
          item.partnerCurrency,
          item.editionId || '',
          true,
        ) > 0,
    );
    this.orderSummary$ = this.stairstepService.getOrderBreakDown(nonFreeOrderConfirmationItems);
    this.orderCurrency = this.stairstepService.getOrderItemsCurrency(nonFreeOrderConfirmationItems);
  }
}
